"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownText = void 0;

var _preact = require("preact");

var DropdownText = function DropdownText(_ref) {
  var timezones = _ref.timezones,
      selected = _ref.selected,
      label = _ref.label;

  if (timezones.length === 0) {
    return (0, _preact.h)("div", {
      className: "timezone-selector-placeholder"
    }, "Loading timezones...");
  }

  if (selected) {
    return (0, _preact.h)("span", {
      className: "selected"
    }, label ? (0, _preact.h)("div", {
      className: "timezone-selected-label"
    }, label) : null, (0, _preact.h)("div", {
      className: "truncated"
    }, selected.title));
  }

  return (0, _preact.h)("div", {
    className: "timezone-selector-placeholder"
  }, "Choose a timezone");
};

exports.DropdownText = DropdownText;